import React, {useCallback} from "react";
import {FileRejection, useDropzone} from "react-dropzone";
import "./DragAndDrop.css";

interface DragAndDropProps {
  accepted?: boolean;
  className?: string;
  compWidth?: string;
  disabled?: boolean;
  onDrop: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => void;
  innerTitle?: React.ReactNode;
  innerSubTitle?: React.ReactNode;
}

export const DragAndDrop: React.FC<DragAndDropProps> = (props: DragAndDropProps) => {
  const onDrop = useCallback(
      (acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
        props.onDrop(acceptedFiles, rejectedFiles);
      },
      [props.onDrop]
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {"image/png": [".png"], "image/jpeg":[".jpg", ".jpeg"], "application/pdf":[".pdf"]},
    maxSize: 25000000,
    disabled: props.disabled
  });

  return (
      <div className={"DragAndDrop-container"}>
        <div {...getRootProps()} className={"DragAndDrop-innerTitle"}>
          <div className={"DragAndDrop-title"}>
            <a className={"DragAndDrop-link"}>{props.innerTitle}</a>
          </div>
          <div className={"DragAndDrop-subtitle"}>{props.innerSubTitle}</div>
          <input {...getInputProps()} />
        </div>
      </div>
  );
};

DragAndDrop.defaultProps = {
  accepted: false,
  className: undefined,
  compWidth: "",
  disabled: false,
  innerSubTitle: "We currently support JPG, PNG, PDF and make sure your file size is no more than 25MB.",
  innerTitle: "Upload your ID.",
};



// WEBPACK FOOTER //
// ./src/manual-upload/UploadFile/DragAndDrop.tsx